import { gql } from '@apollo/client';

export const GET_APPLICATION_SCREEN = gql`
  query GetApplicationScreen($inviteeId: String) {
    orgName
    orgLogo
    vm {
      screeningQuestions {
        screeningQuestionId
        label
        order
      }
      invitee(inviteeId: $inviteeId) {
        inviteeId
        email
      }
      screeningFailureContent {
        screeningFailureContentId
        content
        isEnabled
      }
    }
  }
`;

export interface ApplicationFormFormik {
  name: string;
  email: string;
  password: string;
  screeningAnswers: Array<{
    screeningQuestionId: string;
    answer: string;
  }>;
}
